import { createContext, useContext } from 'react';

export const NostoContext = createContext();
export const useNostoContext = () => {
  const context = useContext(NostoContext);
  if (!context) {
    throw new Error(
      'NostoContext cannot be rendered outside the NostoContext.Provider',
    );
  }
  return context;
};
